const transactionTypes = {
    SOLD: [
        'Allocation/Over The Counter Sale',
        'Auction',
        'Consideration Includes Other Property Or Represents A Partial Interest',
        'Consideration Includes Plant And/Or Equipment',
        'Consideration Represents Whole Interest For Property',
        'Full Property Transfer, Land And Improvement',
        'Land Plant And Equipment (Breakdown)',
        'Land Plant And Equipment (No Breakdown)',
        'More Than One Title',
        'Multiple',
        'Multi-Sale',
        'Normal Sale',
        'Portion Of Land',
        'Qhc Rental Purchase',
        'Rebated Sale',
        'Serviced Land/Floor Level Transfer',
        'Time Share',
        'Transfer For Full Monetary Consideration',
        'Unknown',
        'Pending Settlement Advice',
    ],
    SOLD_NZ: [
        'Multi',
        'Normal Sale',
        'Whole',
    ],
    TRANSFERRED: [
        'Survivorship',
        'Change Of Address',
        'Change Of Description',
        'Change Of Name (Marriage)',
        'Change Of Name And Address',
        'Change Of Ownership',
        'Change Of Ownership For No Monetary Consideration Or Undisclosed Consideration',
        'Change Of Tenure',
        'Change Of Use',
        'Change Of Use Down',
        'Change Of Use Up',
        'Cosmetic Change',
        'Council Advice',
        'Council Request',
        'Court Order',
        'Department of Housing Transfer',
        'Extraordinary Circumstance',
        'Family Sale',
        'Gift',
        'Gift - Half Share',
        'Love And Affection',
        'Mortgagee In Possesion',
        'Natural Love And Affection',
        'Nils and wills',
        'No Monetary Consideration',
        'No Sale Recorded',
        'Not True Value',
        'Part',
        'Part Sale',
        'Pursuant To A Will',
        'Rateable To Non Valued',
        'Rates Arrears',
        'Record Of Marriage',
        'Trans By/Record Of Death',
        'Transfer',
        'Transfer By Third Party',
        'Transfer Unadjusted',
        'Transmission By Bankruptcy',
        'Transmission By Death',
    ],
    TRANSFERRED_NZ: [
        'Part',
        'Transfer sale',
    ],
    TRANSACTED: [
        'Acquisition',
        'Acquisition Of Privilege',
        'Adjustment',
        'Alter After Grievance',
        'Amalgamated',
        'Amalgamation',
        'Amended Area',
        'Amended Description',
        'Amended Transfer',
        'Appeal',
        'Area',
        'Asset Valuation',
        'Bcc Advice',
        'Building Unit Plan',
        'Bulk Change',
        'Cancellation',
        'Cancelled',
        'Cancelled Assessment/Historic',
        'Cancelled/Historic/Non-Active Assessments',
        'Cane Advice',
        'Cessation Of Zoned Rural Land',
        'Change Of Lease',
        'Comm/Retail Development',
        'Consideration And Pursuant To A Deed Of Assignment',
        'Conversion',
        'Correction',
        'Deed Of Grant',
        'Dwelling',
        'Easement',
        'Easement (Burden Or Benefit)',
        'Error Or Conversion Error',
        'Expired (Determined)',
        'Extra Ordinary',
        'Flooding',
        'Forfeited',
        'Forrestry Advice',
        'Freehold',
        'Gg.P1340 (Leave Out Page)',
        'Government Gazette',
        'Group Title Plan',
        'Head Office Or Title Search',
        'Hotels',
        'Industrial Inc Redevelop',
        'Islands',
        'Land Admin Commission',
        'Land Court',
        'Land Taken',
        'Lands Advice',
        'Lease Advice',
        'Letter',
        'Local Government',
        'Loss Of Privilege',
        'Main Roads Advice',
        'Mastercard/Header/Parent Assessment',
        'Mines Advice Or Mines',
        'Multi-Unit Residential',
        'Multi-Unit Sites',
        'Negotiated Sale',
        'New Lease',
        'New Portion',
        'Non Valued To Rateable',
        'Not Previously Valued',
        'Objection',
        'Occupied (Qhc)',
        'Offset Adjustment',
        'Permit To Occupy',
        'Public Works',
        'Railway Advice Or Qgr',
        'Railway Land',
        'Real Property Search',
        'Redevelopment Residential',
        'Registered Plan',
        'Reinstated',
        'Relativity',
        'Rented',
        'Renumbering',
        'Request',
        'Reserve',
        'Residential Redevelopment',
        'Resumed',
        'Resurvey',
        'Resurvey (Survey)',
        'Revaluation',
        'Reverted-Revision-Rescind',
        'Rezoning',
        'Rural Acreages',
        'Separate Rating',
        'Service Station Or Site',
        'Single Unit Dwelling',
        'Split',
        'Stock Grazing Permit',
        'Subdivided Land',
        'Surrender',
        'Surrender Lease',
        'T/C',
        'Tobacco Quota',
        'Transfer Of A Partial Interest Or An Interest In Multiple Titles',
        'Unit/Group Title Plans',
        'Unspecified - Cancelled or Non-Active Assessment',
        'Vacant',
        'Vacant Land',
        'Valuer General Declares Land As Rural',
        'Vegetation Management Action',
        'Zoning',
    ],
    TRANSACTED_NZ: [
        'Unclassified',
        'Other',
        'NULL',
    ],
};

export default transactionTypes;
